import { useEffect, useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./index.module.scss";
import classNames from "classnames";
import { StarFilled, StarOutlined } from "@ant-design/icons";
import { Tooltip, message } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setIsOpen } from "@/store/modules/user";
import {
  getDetail,
  collectResource,
  cancelCollectResource,
  collectStatus,
} from "@/apis/discover";

// 组件导入
import InfoIntroduction from "./components/infoIntroduction";
import Description from "./components/description";
import HowTouse from "./components/howToUse";
import SubjectTag from "./components/subjectTag";
import SpatialMap from "./components/spatialMap";
// import FileList from "./components/fileList";
import Contributors from "./components/contributors";
import HowToCite from "./components/howToCite";
import Comments from "./components/comments";
import NewComment from "./components/newComment";
import RelatedResource from "./components/relatedResource";
import intl from "react-intl-universal";
import FileManager from "./components/FileManager/index.jsx";
import DetailTitle from "@/components/DetailTitle";
// import RecommendResource from "@/components/RecommendResource"
import SelectedResource from "./components/SelectedResource";
const DataDetail = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.user);
  const token = useMemo(() => userInfo?.token, [userInfo]);
  const location = window.location.href;
  const [isCollect, setIsCollect] = useState(false);
  // 获取url中的id
  let [searchParams] = useSearchParams();
  const resourceUuid = searchParams.get("id");
  const [firstType, setFirstType] = useState("");
  const [secondType, setSecondType] = useState("");
  const [info, setInfo] = useState({});
  const [des, setDes] = useState("");
  const [tags, setTags] = useState([]);
  const [coordInfo, setCoordInfo] = useState({});
  const [files, setFiles] = useState([]);
  const [contributor, setContributor] = useState([]);
  const [howToCite, setHowToCite] = useState({});
  const [useFile, setUseFile] = useState([]);

  const [relatedResources, setRelatedResources] = useState("");
  const [serverApi, setServiceAPI] = useState("");
  const [time, setTime] = useState(new Date().getTime());

  // 获取详情信息
  const getDetailInfo = () => {
    getDetail({
      resourceUuid: resourceUuid,
    })
      .then((res) => {
        const result = res.data;
        setFirstType(result.firstType);
        setSecondType(result.secondType);
        let size = 0;
        let arr = result.files?.map((item) => {
          size = size + Number(item.fileSize);
          return item.fileFormat;
        });
        arr = [...new Set(arr)];
        const authors = result.authors.map((item) => item.author).join(",");
        setInfo({
          title: result.title,
          author: authors,
          contributor: result.contributors
            ? result.contributors[0].nickname
            : "",

          contributorId: result.contributors
            ? result.contributors[0].uuid
            : "",
          isDownloadable: result.isDownloadable,
          isComputable: result.isComputable,
          dataType: result.resourceType?.typeName,
          viewTimes: result.viewTimes,
          Volumes: size,
          collectTimes: result.collectTimes,
          createTime: result.createTime,
          downloadTimes: result.downloadTimes,
          updateTime: result.updateTime,
          contentTypes: arr,
          configuration: result.configuration,
          dataSource: result.dataSource,
          sampleType: result.sampleType,
        });

        const tagsArr = result.tags.map((item) => {
          return item.tag;
        });
        setTags(tagsArr);
        setDes(result.description);
        setCoordInfo({
          latitude: result.latitude,
          longitude: result.longitude,
          areaName: result.areaName,
          startDate: result.startDate,
          endDate: result.endDate,
        });
        setFiles(result.files || []);
        setContributor(result.contributors || []);
        setHowToCite({
          howToCite:
            result.howToCite ||
            `${authors},Open Geospatial Engine Alliance,${location}`,
          ...result.license,
        });
        setUseFile(result.howToUse ? [result.howToUse] : []);
        setRelatedResources(result.relatedResources);
        setServiceAPI(result.serviceApi);
      })
      .catch((err) => { });
  };

  const getIsCollect = () => {
    collectStatus({
      resourceUuid: resourceUuid,
    })
      .then((res) => {
        setIsCollect(res.data);
      })
      .catch((err) => { });
  };

  useEffect(() => {
    if (resourceUuid) {
      getDetailInfo();
    }
  }, [resourceUuid]);

  useEffect(() => {
    if (token && resourceUuid) {
      getIsCollect();
    } else {
      setIsCollect(false);
    }
  }, [token]);

  // 收藏资源
  const collect = () => {
    if (token) {
      collectResource({
        resourceUuid: resourceUuid,
      })
        .then((res) => {
          message.success(intl.get("Successful collection"));
          // if (localStorage.getItem("collections")) {
          //   dispatch(
          //     setCollections(
          //       localStorage.getItem("collections") + "," + resourceUuid
          //     )
          //   );
          // } else {
          //   dispatch(setCollections(resourceUuid));
          // }
          setIsCollect(true);
        })
        .catch((err) => { });
    } else {
      dispatch(setIsOpen(true));
    }
  };

  // 取消收藏资源
  const cancelCollect = () => {
    cancelCollectResource({
      resourceUuid: resourceUuid,
    })
      .then((res) => {
        message.success(intl.get("Uncollect successfully"));
        // dispatch(
        //   setCollections(
        //     localStorage
        //       .getItem("collections")
        //       .split(",")
        //       .filter((item) => item !== resourceUuid)
        //   )
        // );
        setIsCollect(false);
      })
      .catch((err) => { });
  };

  return (
    <div className={classNames("container", styles.dataDetailBox)}>
      {secondType && (
        <div className={styles.tabWrap}>
          <a
            href={`/discover/open-datasets?type=${firstType}&title=${firstType}`}
          >
            {intl.get("Header." + firstType.replace(/(?<!^)([A-Z])/g, " $1"))}
          </a>
          {" > "}
          <a
            href={`/discover/open-datasets?type=${secondType}&title=${firstType}`}
          >
            {secondType === "OpenAITrainingData"
              ? intl.get("Header.Open AI Training Data")
              : secondType === "TrainingCourseMaterials"
                ? intl.get("Header.Training & Course Materials")
                : intl.get(
                  "Header." + secondType.replace(/(?<!^)([A-Z&])/g, " $1")
                )}
          </a>
        </div>
      )}
      <InfoIntroduction
        info={info}
        firstType={firstType}
        secondType={secondType}
      />
      <Description des={des} title="Description" />
      {(firstType === "OpenTools" || firstType === "OpenApps") && (
        <HowTouse resourceUuid={resourceUuid} files={useFile} />
      )}
      <SubjectTag tags={tags} />
      {firstType === "OpenData" && <SpatialMap coordInfo={coordInfo} />}
      {secondType !== "OpenDataServices" &&
        secondType !== "OpenProcessServices" &&
        secondType !== "OpenWebApps" && (
          <div>
            {/* <FileList files={files} resourceUuid={resourceUuid} secondType={secondType} firstType={firstType} resourceType={info.dataType} />
				{info.configuration && <div className={styles.configurationBox}>
					<h4>Config</h4>
					<div>{info.configuration}</div>
				</div>} */}
            <DetailTitle
              title={firstType === "OpenData" ? "Data" : "Content"}
            />
            <FileManager resourceUuid={resourceUuid} files={files} />
          </div>
        )}
      {(firstType === "OpenDocs" ||
        firstType === "OpenApps" ||
        secondType === "OpenDataServices" ||
        secondType === "OpenProcessServices") && (
          <Description des={serverApi} title="Service API" />
        )}
      <Contributors contributor={contributor} />
      {relatedResources && (
        <RelatedResource relatedResources={relatedResources} />
      )}
      <HowToCite howToCite={howToCite} />
      <Comments resourceUuid={resourceUuid} time={time} />
      <NewComment resourceUuid={resourceUuid} setTime={setTime} />
      <p className={styles.collectBox}>
        {!isCollect && (
          <Tooltip title={intl.get("Collect")}>
            <StarOutlined onClick={collect} />
          </Tooltip>
        )}
        {isCollect && (
          <Tooltip title={intl.get("Cancel Collection")}>
            <StarFilled onClick={cancelCollect} />
          </Tooltip>
        )}
      </p>
      <div>
        <h2>{intl.get("Selected Resources")}</h2>
        <SelectedResource secondType={secondType} />
      </div>

    </div>
  );
};
export default DataDetail;
